import axios from 'axios';
import i18n from 'i18next';
import { ErrorResult } from '.generated/api';

export const localizeAuthorizationError = (error: unknown): unknown => {
  if (axios.isAxiosError(error) && error.response?.status === 401) {
    const data: ErrorResult | undefined = error.response.data;
    if (data?.errorMessage === 'Unauthorized' && !data.errorCode) {
      data.errorMessage = i18n.t('validation.action_not_authorized', {
        ns: 'translations',
      });
    }
  }
  return error;
};
